import { createContext } from 'react';

import { ReportIssueState } from './report-issue.model';

export const ReportIssueContext = createContext<ReportIssueState | undefined>(undefined);
